import { EditorState } from 'draft-js';
import Task1 from 'models/task1';

import { generateKey } from 'constants/helper';

export const ADD_TASKS = 'ADD_TASKS';
export const ADD_NEW_TASK = 'ADD_NEW_TASK';
export const ENABLE_EDITING = 'ENABLE_EDITING';
export const DISABLE_EDITING = 'DISABLE_EDITING';
export const ADD_TASK = 'ADD_TASK';
export const UPDATE_TASK = 'UPDATE_TASK';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const TOGGLE_UPDATING = 'TOGGLE_UPDATING';
export const ON_CHECK_TOGGLE = 'ON_CHECK_TOGGLE';
export const APPEND_TASKS = 'APPEND_TASKS';
// find task if id is present, otherwise using the key
function findTaskIndex({ tasks = [], id, key }) {
  const findKey = id ? 'id' : 'key';
  const keyy = id || key;
  let index = tasks.findIndex((task) => task[findKey] === keyy);
  // find index using key if unable to find using id
  if (index < 0 && id && key) {
    index = tasks.findIndex((task) => task.key === key);
  }
  return index;
}

export default function tasksReducer(state, action) {
  switch (action.type) {
    case ADD_NEW_TASK: {
      const { employee, ...other } = action.data;
      const newTask = new Task1({
        lastEditedBy: employee,
        to: employee,
        from: employee,
        toIds: [employee],
        editorState: EditorState.createEmpty(),
        ...other,
      });
      newTask.isEditing = true;
      // need key to remove task because id will be undefined in that case
      newTask.key = generateKey(7);
      const newState = [newTask, ...state];
      return newState;
    }
    case ADD_TASKS: {
      return [...action.data.tasks];
    }

    case APPEND_TASKS: {
      return [...state, ...action.data.tasks];
    }

    case DISABLE_EDITING: {
      return state.map((task) => {
        task.isEditing = false;
        return task;
      });
    }
    case ADD_TASK: {
      const newState = [action.data.task, ...state];
      return newState;
    }
    case UPDATE_TASK: {
      const index = findTaskIndex({ tasks: state, id: action.data.id, key: action.data.key });
      if (index === -1) return state;
      const newState = [...state];
      newState[index] = { ...action.data.task };
      return newState;
    }
    case REMOVE_ITEM: {
      const { taskId, key } = action.data;
      // either a taskId or key should be present to find the task in the array
      if (!taskId && !key) return state;
      if (taskId) return state.filter((task) => task.id !== taskId);
      return state.filter((task) => task.key !== key);
    }
    case TOGGLE_UPDATING: {
      return state.map((task) => {
        if (task.id === action.data.taskId) task.isUpdating = !task.isUpdating;
        return task;
      });
    }
    case ON_CHECK_TOGGLE: {
      const index = findTaskIndex({ tasks: state, id: action.data.id, key: action.data.key });
      if (index === -1) return state;
      const newState = [...state];
      newState[index].completionDate = newState[index].completionDate ? null : new Date();
      return newState;
    }
    case ENABLE_EDITING: {
      const newState = state.map((task) => {
        if (task.id === action.data.taskId) {
          task.isEditing = true;
        } else {
          task.isEditing = false;
        }
        return task;
      });

      return newState;
    }
    default:
      return state;
  }
}
